import { render, staticRenderFns } from "./KnowledgeParameters.vue?vue&type=template&id=64faeae8&"
import script from "./KnowledgeParameters.vue?vue&type=script&lang=js&"
export * from "./KnowledgeParameters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports